const UrlApi = {

  // baseUrl: "http://localhost:3000/admin",
  // baseUrlImage: "http://localhost:3000/uploads/",
  baseUrl: "https://api.whitetaxi.net/admin/",
  baseUrlImage: "https://api.whitetaxi.net/uploads/",

  // auth
  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    signup: "auth/signup",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
  },

  admins_logs: {
    get: "logs/get",
    edit: "logs/edit",
  },


  stats: {
    get: "stats/get",
    edit: "stats/edit",
    add: "stats/add",
    delete: "stats/delete",
  },

  fleet: {
    get: "fleet/get",
    add: "fleet/add",
    edit: "fleet/edit",
    delete: "fleet/delete",
  },

  testimonials: {
    get: "testimonials/get",
    add: "testimonials/add",
    edit: "testimonials/edit",
    delete: "testimonials/delete",
  },

  features: {
    get: "features/get",
    add: "features/add",
    edit: "features/edit",
    delete: "features/delete",
  },

  settings: {
    get: "settings/get",
    edit: "settings/edit",
  },

  contact: {
    get: "settings/get",
    edit: "settings/edit",
  },

  legalInformation: {
    get: "settings/get",
    edit: "settings/edit",
  },


  intro_call: {
    get: "intro_call/get",
    add: "intro_call/add",
    edit: "intro_call/edit",
    delete: "intro_call/delete",
  },

  // messages: {
  //   get: "messages/get",
  //   delete: "messages/delete",
  // },
};

export default UrlApi;
